/**
 * 导出一个全局的 React 和 ReactDOM
 */
import React from 'react';
import ReactDOM from 'react-dom';

window.React = React;
window.ReactDOM = ReactDOM;